module.exports = __webpack_public_path__ + "img/build.c9952c5e.webp";